<div class="single-select-dropdown-filter-constainer" tamDropDownOutside (clickOutside)="onClickOutside($event)">
    <input type="text" readonly [value]="inputValue" (focus)="showPopup($event)" *ngIf="!hideInput" class="textInput"
        [disabled]='dropdownConfig.disabledInput' [placeholder]="dropdownConfig.placeholder">
    <div *ngIf="hideInput">
        <ng-container *ngTemplateOutlet="customContent"></ng-container>
    </div>
    <kendo-popup [anchor]="anchor" *ngIf="showSel">
        <div class="selectContainer">
            <div class="row" style="position: relative;">
                <input type="text" placeholder="Search" [(ngModel)]="searchValue" class="searchInput"
                    (input)="searchData()">
                <div class="icon-search">
                    <smart-icon name="search"></smart-icon>
                </div>
            </div>
            <div class="items">
                <ng-container *ngIf="freezingItemsConfig">
                    <div class="row top-items-container" *ngFor="let item of freezingItemsConfig;trackBy:trackByFn">
                        <label (click)="changeSelectedState(item, $event)" class="label-container">
                            {{item.name}}
                        </label>
                    </div>
                    <hr>
                </ng-container>
                <div *ngIf="items.length > 0">
                    <div *ngFor="let item of items;trackBy:trackByFn" class="row">
                        <label (click)="changeSelectedState(item, $event)" class="label-container">
                            {{item.name}}
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </kendo-popup>
</div>